<template lang="pug">
section
  s-page-title(title='Банеры для блога')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
      template(slot='controls')
        v-layout
          v-flex(xs-12)
            s-region-picker(
              :value='dataFilter.region_id'
              @change='setRegion'
            )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.name }}
          td {{ props.item.regions }}
          td {{ props.item.link }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='seo/banners'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'Название',
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Регионы',
        align: 'left',
        sortable: true,
        value: 'regions'
      },
      {
        text: 'Ссылка',
        align: 'left',
        sortable: true,
        value: 'link'
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'seo/faqs',
      itemValue: 'id',
      itemText: 'question'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    setRegion(region_id = null) {
      this.setDataFilter({ region_id })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Seo.Banners.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    getIds(array) {
      if (!array) return ''
      return array.map((item)=> item.id).join(', ')
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('seo/banners', ['fetchList', 'destroy']),
    ...mapMutations('seo/banners', ['setDataFilter'])
  },

  computed: {
    ...mapState('seo/banners', ['total', 'dataFilter']),
    ...mapGetters('seo/banners', ['list', 'isLoading']),
  }
}
</script>
